export type TenderType = 'sale' | 'lease' | 'auction' | 'other';
export type Voivodeship = 'zachodniopomorskie' | 'lubuskie';

export interface FilterState {
  voivodeship: Voivodeship | null;
  tender_type: TenderType | null;
  min_price: number | null;
  max_price: number | null;
}

export const DEFAULT_FILTERS: FilterState = {
  voivodeship: null,
  tender_type: null,
  min_price: null,
  max_price: null,
};

export interface MapBounds {
  min_lat: number;
  max_lat: number;
  min_lng: number;
  max_lng: number;
}

export interface ParcelSummary {
  id: string;
  parcel_number: string;
  tender_type: TenderType | null;
  price: number | null;
  tender_date: string | null;
  lat: number;
  lng: number;
}

export interface ParcelDetail {
  id: string;
  parcel_number: string;
  district: string | null;
  commune: string | null;
  area_m2: number | null;
  tender_type: TenderType | null;
  price: number | null;
  tender_date: string | null;
  source_url: string;
  source_name: string;
  geometry: GeoJSON.Polygon | null;
}

export interface GeoJSONFeature {
  type: 'Feature';
  geometry: {
    type: 'Point';
    coordinates: [number, number];
  };
  properties: {
    id: string;
    parcel_number: string;
    tender_type: TenderType | null;
    price: number | null;
    tender_date: string | null;
  };
}

export interface GeoJSONFeatureCollection {
  type: 'FeatureCollection';
  features: GeoJSONFeature[];
}

export interface Stats {
  total_tenders: number;
  total_parcels: number;
  total_sources: number;
  tenders_by_type: Record<string, number>;
  tenders_by_voivodeship: Record<string, number>;
  last_crawl_at: string | null;
}
